export default __webpack_public_path__ + "static/media/glrc-course.pastry_essentials.36aa09f6.png";